MG['cropper'] = {}
MG.cropper.cropWidths = {
  glv:380,
  ball:300,
  mark:340
};
MG.cropper.getCropOptions = function(cropType){
  let cropWidth = MG.cropper.cropWidths.glv;
  if (MG.crop_width) {
    cropWidth = MG.crop_width;
  } else {    
    if (cropType in MG.cropper.cropWidths){
      cropWidth = MG.cropper.cropWidths[cropType];
    }
  }
	return  {
    aspectRatio: 1 / 1,
    autoCropArea: 1,
    background: true,
	  center: true,
	  checkOrientation: true,
    cropBoxMovable: true,
	  cropBoxResizable: true,
	  dragMode: 'move',
	  guides: true, 
    highlight: true,
    modal: true,
	  movable: true,
    responsive: true,
	  rotatable: true,
	  scalable: true,
	  toggleDragModeOnDblclick: false,
    viewMode: 0,
	  wheelZoomRatio: .1,
	  zoomable: true,
	  zoomOnTouch: true,
	  zoomOnWheel: true,
	  minContainerWidth: cropWidth,
	  minContainerHeight: cropWidth,
	  minCanvasWidth: cropWidth,
	  minCanvasHeight: cropWidth,
	  minCropBoxWidth: 80,
	  minCropBoxHeight: 80,
	//crop(event) {
		//console.log(event.detail.x);
		//console.log(event.detail.y);
		//console.log(event.detail.width);
		//console.log(event.detail.height);
		//console.log(event.detail.rotate);
		//console.log(event.detail.scaleX);
		//console.log(event.detail.scaleY);
	//},
    };
};

MG.cropper.getRoundedCanvas = function (sourceCanvas) {
	var canvas = document.createElement('canvas');
	var context = canvas.getContext('2d');
	var width = sourceCanvas.width;
	var height = sourceCanvas.height;

	canvas.width = width;
	canvas.height = height;
	context.imageSmoothingEnabled = true;
	context.drawImage(sourceCanvas, 0, 0, width, height);
	context.globalCompositeOperation = 'destination-in';
	context.beginPath();
	context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
	context.fill();
	return canvas;
}

		//const cropperModal = new bootstrap.Modal(document.getElementById("cropperModal"),);
MG.cropper.cropperModal = document.getElementById("cropperModal");

MG.cropper.imgData = document.getElementById('imgData');
MG.cropper.image = document.getElementById('image');
MG.cropper.cropper = new Cropper(MG.cropper.image, MG.cropper.getCropOptions('glv'));

MG.cropper.rotator = document.getElementById("rotator");
MG.cropper.rotator.oninput = function () {
  MG.cropper.cropper.rotateTo(this.value);
}

MG.cropper.imgFile = document.getElementById("imgFile");
MG.cropper.imgFile.onchange = function () {
  if (this.files && this.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      MG.cropper.cropper.replace(e.target.result, false);
    };
    reader.readAsDataURL(this.files[0]);
  }
}
MG.cropper.cropMe = document.getElementById("cropMe");
MG.cropper.cropMe.onclick = function () {
  this.disabled = true;
  let cropSize = MG.cropper.cropper.options.minCanvasHeight;                                        
  croppedCanvas = MG.cropper.cropper.getCroppedCanvas({ width: cropSize, height: cropSize, imageSmoothingEnabled: true, imageSmoothingQuality: "high" });
  // Round
  roundedCanvas = MG.cropper.getRoundedCanvas(croppedCanvas);
  // Show
  var hld = roundedCanvas.toDataURL();
  if (MG.cropper.imgData) {
    MG.cropper.imgData.value = hld.replace(/^data:image\/(png|jpg);base64,/, "");
  }
    MG.AWS.uploadPhoto(MG.cropper.imgData,MG.cropper.cropperModal,MG.cropper.setImgFileName,cropSize);
}

MG.cropper.openModal = document.getElementById("openModal");
MG.cropper.openModal.onclick = function () {
  MG.cropper.cropMe.disabled = false;
  MG.cropper.cropperModal.style.display = "block";
  MG.cropper.cropper.replace(image.src,false);
}

MG.cropper.closes = document.getElementsByClassName("close");
Array.prototype.forEach.call(MG.cropper.closes, function(el) {
      el.onclick = function() {
 			MG.cropper.cropperModal.style.display = "none";
	}                                                 
});

MG.cropper['setImgFileName'] = function (path) {
  MG.cropper.cropMe.disabled = false;
  if (!MG.cropper.previewImg) {
    MG.cropper.previewImg = document.getElementById('previewImg');
  }
  if (MG.cropper.previewImg) {
    MG.cropper.previewImg.src = path;
    MG.cropper.previewImg.style.visibility = 'visible';
    MG.cropper.previewImg.style.display = 'inline';
  }
  if (!MG.cropper.imgFileName) {
    MG.cropper.imgFileName = document.getElementById('imgFileName');
  }
  if (MG.cropper.imgFileName){
    MG.cropper.imgFileName.value = path;
    MG.cropper.imgFileName.setCustomValidity('');
  }
  MG.cropper.imgFileName.setAttribute('data-imgPath', path);
  // Always set value when an image is saved — toggle state controls the name attribute
  MG.cropper.imgFileName.value = path;
  MG.cropper.clsImgFileNames = document.getElementsByClassName("imgFileName");
  Array.prototype.forEach.call(MG.cropper.clsImgFileNames, function(el) {
    el.value = path;
  });

}
